import { Pipe, PipeTransform } from '@angular/core';
import { Dokument } from '../../../../shared/models/dokument';
import { ApplicationGroup } from '../../../../shared/enums/application-group.enum';

@Pipe({
  name: 'isMoveToOrganizationActive',
  pure: true,
  standalone: true,
})
export class IsMoveToOrganizationActivePipe implements PipeTransform {
  transform(application: Dokument | null | undefined): boolean {
    const grupa = (application?.typDokumentu as any)?.grupa as ApplicationGroup;
    return [ApplicationGroup.OP, ApplicationGroup.ON].includes(grupa);
  }
}
